import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import TimelineList from "ui-components/Timeline/TimelineList";
import TimelineItem from "ui-components/Timeline/TimelineItem";
import { getPORecvLog } from "services/data.inbound.service";
import Drawer from "ui-components/Drawer";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Qty Expected", id: "qtyExpected" },
  { label: "Qty Received", id: "qtyReceived" },
  { label: "DO No", id: "vdoNo" },
  { label: "Inv No", id: "vInvNo" },
  { label: "MLN", id: "mln" },
  { label: "Carton ID", id: "cartonID" },
  { label: "Expiry Date", id: "expiryDate" },
];

function PORecvLog({ open, setOpen, logRequest, setLogRequest, setAlert }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);
  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["porecv-log", { logRequest }],
    queryFn: () => getPORecvLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      const renderTimelineItems = item.logs.map(({ id, ...log }) => (
        <TimelineItem key={id} {...log} />
      ));
      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>Recv Number : </b>
                {item.recvCode}
              </Grid>
              <Grid item xs={6}>
                <b>Date Received : </b>
                {item.dateReceived}
              </Grid>
              <Grid item xs={6}>
                <b>ASN Code : </b>
                {item.asnCode}
              </Grid>
              <Grid item xs={6}>
                <b>PO Number : </b>
                {item.poNumber}
              </Grid>
              <Grid item xs={6}>
                <b>Warehouse Code : </b>
                {item.warehouseCode}
              </Grid>
              <Grid item xs={12}>
                <b>Seller Company : </b>
                {item.sellerCompany}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
          <TimelineList title="Logs">{renderTimelineItems}</TimelineList>
        </>
      );
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="800px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default PORecvLog;
